/* eslint-disable no-restricted-globals,radix,no-case-declarations,no-restricted-syntax */
import {
  fetchingSvg,
  convertingDifferentMeasurementUnitIntoPx,
} from '@/components/Helper';

export default class ImageObject {
    /**
     * Method 1: Init
     * Method 2: InitFromXML
     * Method 3: GetHTML
     * Method 4: GetXML
     * Method 5: CloneObject
     * Method 6:
     */
  // TODO:All Data
    data = {
      croppedSrc:                     'none',
      type:                           'image',
      AllowMove:                      true,
      AllowResize:                    true,
      AllowRotate:                    true,
      AlternativeImageUrls:           [],
      AlternativeImageUrlsResVersion: [],
      DefaultImageUrl:                '',
      Height:                         0,
      Id:                             -1,
      ImageType:                      '',
      ImageExtension:                 '',
      IsGrayScale:                    true,
      IsVisible:                      true,
      IsHFlipped:                     false,
      IsVFlipped:                     false,
      LockAspectRatio:                false,
      Name:                           '',
      PageNo:                         -1,
      PdfSortOrder:                   -1,
      RotateDegree:                   0,
      Width:                          0,
      X:                              0,
      Y:                              0,
      stencilDefaultPositionTop:      null,
      stencilDefaultPositionLeft:     null,
      stencilScale:                   1,
      scaleX:                         1,
      scaleY:                         1,
      locked:                         false,
      elementIndex:                   -1,
      isSelected:                     false,
      isEditableForRightPanel:        false,
      cropScaleX:                     1,
      cropScaleY:                     1,
      cropOffsetX:                    0,
      cropOffsetY:                    0,
      isCircularCrop:                 0,
      HighResV2Height:                0,
      HighResV2Width:                 0,
      effects:                        {
        brightness:   { value: 100 / 2 },
        contrast:     { value: 100 / 2 },
        saturation:   { value: 100 / 2 },
        blur:         { value: 0 },
        tint:         { value: 0, color: '#000' },
        vignette:     { value: 0 },
        transparency: { value: 100 },
      },
      SvgProperty: {
        content:      '',
        DefaultColor: '#000000',
        StrokeColor:  '#000000',
        StrokeWidth:  0,
        svgScaleX:    1,
        svgScaleY:    1,
        style:        'scale(1, 1)',
      },
      HighResPath:                   null,
      isImageAddedOnCanvasFromModel: false,
      croppedHighResPath:            'none',
      DefaultImageHeight:            0,
      DefaultImageWidth:             0,
      animation:                     {
        speed:     1,
        style:     '',
        startTime: 0.0,
        duration:  0.0,
        onEnter:   false,
        onExit:    false,
        distance:  1,
      },
      isAnimated: false,
      isGradient: false,
      gradient: {
        angle: 0,
        colors: [
          {
            id: '1',
            position: 0,
            color: 'red',
            isSelected: true,
            rgba: 'rgba(255,0,0,1)'
          },
          {
            id: '2',
            position: 94,
            color: 'yellow',
            isSelected: false,
            rgba: 'rgba(234,239,44,1)'
          },
        ]
      }
    }

    async initFromXML(xmlImageObject) {
      for (const imageProperty of xmlImageObject.children) {
        switch (imageProperty.tagName) {
          case 'Id':
            this.data.Id = imageProperty.innerHTML;
            break;
          case 'Name':
            this.data.Name = imageProperty.innerHTML;
            break;
          case 'PageNo':
            this.data.PageNo = parseFloat(imageProperty.innerHTML);
            break;
          case 'Width':
            this.data.Width = parseFloat(imageProperty.innerHTML);
            break;
          case 'Height':
            this.data.Height = parseFloat(imageProperty.innerHTML);
            break;
          case 'X':
            this.data.X = parseFloat(imageProperty.innerHTML);
            break;
          case 'Y':
            this.data.Y = parseFloat(imageProperty.innerHTML);
            break;
          case 'PdfSortOrder':
            const pdfSortOrder     = parseInt(imageProperty.innerHTML);
            this.data.PdfSortOrder = !isNaN(pdfSortOrder) ? pdfSortOrder : -1;
            break;
          case 'SortOrder':
            const sortOrder     = parseInt(imageProperty.innerHTML);
            this.data.SortOrder = !isNaN(sortOrder) ? sortOrder : -1;
            break;
          case 'LockAspectRatio':
            this.data.LockAspectRatio = imageProperty.innerHTML;
            break;
          case 'AllowMove':
            this.data.AllowMove = imageProperty.innerHTML;
            break;
          case 'AllowResize':
            this.data.AllowResize = imageProperty.innerHTML;
            break;
          case 'AllowRotate':
            this.data.AllowRotate = imageProperty.innerHTML;
            break;

          case 'ImageType':
            this.data.ImageType = imageProperty.innerHTML;

            break;
          case 'DefaultImageUrl':
            this.data.DefaultImageUrl = `${imageProperty.innerHTML} `;
            break;
          case 'AlternativeImageUrls':
            const images                   = imageProperty.innerHTML;
            this.data.AlternativeImageUrls = (images.includes('\n')) ? images.split('\n').filter(Boolean) : (images.trim()) ? [images] : [];
            break;
          case 'AlternativeImageUrlsWithHighResVersion':// Image
            const AlternativeImageUrlsArray = Array.from(imageProperty.getElementsByTagName('AlternativeImageWithHighRes'));
            if (this.data.ImageType == 'Image' && AlternativeImageUrlsArray.length > 0) {
              AlternativeImageUrlsArray.forEach((cur) => {
                const DefaultImageUrl = cur.getElementsByTagName('DefaultImageUrl')[0].innerHTML;
                const HighResImageUrl = cur.getElementsByTagName('HighResImageUrl')[0].innerHTML;
                const HighResV2Width  = cur.getElementsByTagName('HighResV2Width')[0].innerHTML;
                const HighResV2Height = cur.getElementsByTagName('HighResV2Height')[0].innerHTML;
                this.data.AlternativeImageUrlsResVersion.push({
                  DefaultImageUrl, HighResImageUrl, HighResV2Width, HighResV2Height,
                });
              });
            }
            this.data.AlternativeImageUrlsResVersion.unshift({
              DefaultImageUrl: this.data.DefaultImageUrl, HighResImageUrl: '', HighResV2Width:  '', HighResV2Height: '',
            });


            break;
          case 'IsGrayscale':
            this.data.IsGrayscale = (imageProperty.innerHTML && imageProperty.innerHTML.toLowerCase() == 'true');
            break;
          case 'IsVisible':
            this.data.IsVisible = (imageProperty.innerHTML && imageProperty.innerHTML.toLowerCase() == 'true');
            break;
          case 'IsVFlipped':
            this.data.IsVFlipped = (imageProperty.innerHTML && imageProperty.innerHTML.toLowerCase() == 'true');
            break;
          case 'IsHFlipped':
            this.data.IsHFlipped = (imageProperty.innerHTML && imageProperty.innerHTML.toLowerCase() == 'true');
            break;
          case 'HighResPath':
            this.data.HighResPath = imageProperty.innerHTML;
            break;
          case 'RotateDegree':
            this.data.RotateDegree = imageProperty.innerHTML;
            break;
        }
      }

      this.data.AlternativeImageUrls != null && this.data.AlternativeImageUrls.unshift(this.data.DefaultImageUrl.trim());
      if (this.data.ImageType == 'SVGImage') {
        const resultSvg               = await fetchingSvg(this.data.HighResPath);
        this.data.SvgProperty.content = resultSvg.content;
        // this.data.Width
        const w                            = convertingDifferentMeasurementUnitIntoPx(resultSvg.width);
        const h                            = convertingDifferentMeasurementUnitIntoPx(resultSvg.height); // style="transform-origin: left top; transform: scale(3.94702, 6.36842);
        const scaleX                       = this.data.Width / w;
        const scaleY                       = this.data.Height / h;
        this.data.SvgProperty.svgScaleX    = scaleX || 1;
        this.data.SvgProperty.svgScaleY    = scaleY || 1;
        const style                        = `style="transform-origin: left top; transform: scale(${this.data.SvgProperty.svgScaleX}, ${this.data.SvgProperty.svgScaleY});"`;
        this.data.SvgProperty.style        = `scale(${this.data.SvgProperty.svgScaleX}, ${this.data.SvgProperty.svgScaleY})`;
        this.data.SvgProperty.content      = resultSvg.content.includes('style="transform-origin: left top 0px;"') ? resultSvg.content.replace('style="transform-origin: left top 0px;"', style) : resultSvg.content.replace('style="transform-origin: left top;"', style); // check for the browser compatibility
        this.data.SvgProperty.DefaultColor = resultSvg.color;
      }
      if (this.data.Name === 'z-border') {
        this.data.locked = true;
      }
      try {
        this.data.ImageExtension =  this.data.DefaultImageUrl.split(/[#?]/)[0].split('.').pop().trim();
      } catch (ex) {
        console.log('failed to get image extension');
      }

      return this;
    }

    isSVG() {
      if (this.type == 'image') {
        try {
          const path = this.DefaultImageUrl;
          if (path && path.split(/[#?]/)[0].split('.').pop().trim() == 'svg') {
            return true;
          }
        } catch (ex) {
          return true;
        }
      }
      return false;
    }
}
